import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    fallbackLng: {
      no: ["nb"],
      nn: ["nb"],
      "nn-NO": ["nb"],
      "no-NO": ["nb"],
      "nb-NO": ["nb"],
      "nb-SJ": ["nb"],
      default: ["en"],
    },
    debug: import.meta.env.VITE_NODE_ENV === "development",
    returnEmptyString: false,

    interpolation: {
      escapeValue: false,
    },
    nonExplicitSupportedLngs: true,
    detection: {
      order: ["navigator", "localStorage"],
    },
  });

export default i18n;
